var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.24236 10.8311C8.90669 8.79889 12.017 7.45916 13.5732 6.81186C18.0166 4.96372 18.9399 4.64267 19.5417 4.63207C19.674 4.62974 19.97 4.66254 20.1617 4.81809C20.3235 4.94944 20.3681 5.12686 20.3894 5.25139C20.4107 5.37592 20.4372 5.6596 20.4161 5.88126C20.1753 8.41123 19.1335 14.5508 18.6034 17.3844C18.3791 18.5834 17.9375 18.9855 17.51 19.0248C16.5808 19.1103 15.8752 18.4108 14.9753 17.8208C13.5671 16.8977 12.7716 16.3231 11.4047 15.4223C9.82495 14.3813 10.849 13.8092 11.7493 12.8741C11.9849 12.6294 16.0787 8.90576 16.158 8.56796C16.1679 8.52572 16.1771 8.36824 16.0835 8.28509C15.99 8.20193 15.8519 8.23037 15.7523 8.25298C15.611 8.28504 13.3614 9.77196 9.00336 12.7137C8.36481 13.1522 7.78643 13.3659 7.26822 13.3547C6.69694 13.3423 5.59802 13.0317 4.78109 12.7661C3.77909 12.4404 2.98272 12.2682 3.05206 11.715C3.08818 11.4269 3.48495 11.1323 4.24236 10.8311Z",
    fill: "url(#paint0_linear_2636_3845)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2636_3845",
    x1: 11.7359,
    y1: 4.63196,
    x2: 11.7359,
    y2: 18.9251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.a0148769448723aaebfe666391b7cf5d.svg";
export { ForwardRef as ReactComponent };